<div class="felicitaciones">
    <app-header></app-header>
    <div class="container">
        <div class="row">
            <div class="col-md-12 c-titulo-exito">
                <ng-container *ngIf="!riesgoso; else solicitudIniciada">
                    <img class="icn-ok" src="assets/icons/icon-emoji-mano.png">
                    ¡Felicitaciones {{nombres}}!
                    <p class="c-subtitulo-exito">Has finalizado el proceso de incorporación de forma exitosa,<br>
                        <strong class="text-destacado">te enviaremos el contrato firmado digitalmente a tu email {{correo}}</strong>
                    </p>
                </ng-container>
                <ng-template #solicitudIniciada>
                    Solicitud iniciada
                    <p class="c-subtitulo-exito">
                        Si tu solicitud de incorporación es aprobada,<br>
                        te informaremos el resultado de tu proceso dentro de los próximos días.
                    </p>
                </ng-template>
            </div>
        </div>
        <div class="row">
            <div class="col-lg pr-24">
                <div class="w-left">
                    <app-seguimiento-producto></app-seguimiento-producto>
                    <app-pasos-seguir class="d-none-mobile"></app-pasos-seguir>
                </div>
            </div>
            <div class="col-lg mt-xs-4 mt-sm-4 mt-lg-0 pl-lg-0">
                <div class="w-right">
                    <app-fecha-entrega></app-fecha-entrega>
                    <ng-container *ngIf="loading; else mostrarCarro">
                        <div class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                    </ng-container>
                    <ng-template #mostrarCarro>
                        <app-carro-compra [products]="products$ | async"></app-carro-compra>
                    </ng-template>
                    <app-pasos-seguir class="d-none-desktop"></app-pasos-seguir>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <app-footer> </app-footer>
    </div>
</div>